var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { injectIntl, defineMessages } from "react-intl";
import bannerGirl from "../../../../assets/img/slider-banners/vivo/vivo-banner-girl.png";
import { isStage } from "../../../../shared/domainUtils";
var messages = defineMessages({
    title: {
        id: "vivo_banner.title",
        defaultMessage: "НОВЫЕ ИГРЫ",
    },
    subtitle: {
        id: "vivo_banner.subtitle",
        defaultMessage: "ПОПРОБУЙ СЕЙЧАС",
    },
});
var VivoBanner = /** @class */ (function (_super) {
    __extends(VivoBanner, _super);
    function VivoBanner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            var isActiveSlide = _this.props.isActiveSlide;
            if (isActiveSlide)
                _this.props.push("games", {
                    provider: isStage ? 143 : 627,
                });
        };
        return _this;
    }
    VivoBanner.prototype.render = function () {
        var intl = this.props.intl;
        return (_jsxs("div", __assign({ className: "vivo-games-banner", onClick: this.onClick }, { children: [_jsx("img", { src: bannerGirl, alt: "Try new Games" }), _jsxs("div", __assign({ className: "vivo-games-banner-text" }, { children: [_jsx("h3", { children: intl.formatMessage(messages.title) }), _jsx("p", { children: intl.formatMessage(messages.subtitle) })] }))] })));
    };
    return VivoBanner;
}(Component));
var mapStateToProps = function (state) {
    return {
        langId: state.application.get("languageId"),
    };
};
export default connect(mapStateToProps, { push: push })(injectIntl(VivoBanner));



// WEBPACK FOOTER //
// ./src/components/slider-banner/banners/vivo/VivoBanner.jsx